export namespace RoutePeriodCodeConstants {
  export const PERIOD1 = 'PERIOD1';
  export const PERIOD2 = 'PERIOD2';
  export const PERIOD3 = 'PERIOD3';
}
